import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { CheckItemDto } from "src/app/shared/models/check-dto";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-pos-canvas-items",
	templateUrl: "./pos-canvas-items.component.html",
	styleUrls: ["./../../../pos.scss"],
})
export class PosCanvasItemsComponent implements OnInit, OnChanges {
	@Input() canvasSelected: OOCanvas;
	@Output() canvasSelectedChange = new EventEmitter<OOCanvas>();

	displayModifierDialog: boolean;

	itemSelected: OOCanvasMenuItem;

	constructor(public posService: PosService) {}
	ngOnChanges(changes: SimpleChanges): void {
		this.canvasSelected.menuItems.sort((a, b) => (a.ooMenuItem.name > b.ooMenuItem.name ? 1 : -1));
	}

	ngOnInit(): void {}

	selectItem(cmi: OOCanvasMenuItem) {
		const item = this.posService.venueService.ooMenuItems.find((item) => item.menuItemKey === cmi.menuItemKey);
		this.posService.orderService.orderAddItemToSeat(
			new CheckItemDto({
				menuItemKey: item.menuItemKey,
				name: item.name,
				price: this.posService.venueService.menuItemGetPriceFromNumber(cmi.ooMenuItem, cmi.priceNumber),
				quantity: 1,
				priceNumber: cmi.priceNumber,
			}),
			this.posService.orderService.activeSeat.value.seatKey,
			false
		);

		this.itemSelected = cmi;
		this.itemSelected.ooMenuItem.canvases.forEach((modCanvas) => {
			const canvas = this.posService.venueService.ooCanvases.find((can) => can.canvasKey == modCanvas.canvasKey);
			Object.assign(modCanvas, canvas);
		});

		if (this.itemSelected.ooMenuItem.canvases.some((i) => i.min > 0 || i.max > 0)) {
			this.displayModifierDialog = true;
		}
	}
}
